import flatpickr from "flatpickr";

import { getById, getAll, get } from "@/utilities/querySelector";


const initializeDateRangePicker = () => {
    getAll('nu-dropdown[data-type="date-range"]').forEach(dropdown => {
        if (dropdown.hasAttribute('data-flatpickr-initialized')) return;

        const button = get('.dropdown-button', dropdown);
        const valueSpan = get('.dropdown-value', dropdown);
        const fromInput = get('input[type="hidden"]:first-of-type', dropdown);
        const toInput = get('input[type="hidden"]:last-of-type', dropdown);
        const dropdownElement = get('.dropdown', dropdown);

        if (!button || !valueSpan || !fromInput || !toInput) return;

        const picker = flatpickr(button, {
            mode: 'range',
            dateFormat: 'Y-m-d',
            minDate: 'today',
            maxDate: new Date().fp_incr(365),
            nextArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="11.414" height="7.121" viewBox="0 0 11.414 7.121"><path id="Path_7" data-name="Path 7" d="M-16361.465,9642l5,5,5-5" transform="translate(16362.172 -9641.293)" fill="none" stroke="currentColor" stroke-width="2"/></svg>',
            prevArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="11.414" height="7.121" viewBox="0 0 11.414 7.121"><path id="Path_7" data-name="Path 7" d="M-16361.465,9642l5,5,5-5" transform="translate(16362.172 -9641.293)" fill="none" stroke="currentColor" stroke-width="2"/></svg>',
            defaultDate: [fromInput.value, toInput.value].filter(Boolean),
            clickOpens: false,
            onChange: function(selectedDates) {
                if (selectedDates.length === 1) {
                    valueSpan.textContent = `${flatpickr.formatDate(selectedDates[0], 'j M Y')}`;

                    // Allow single date
                    if (!this.calendarContainer.querySelector('.single-date-confirm')) {
                        const confirmBtn = document.createElement('button');
                        confirmBtn.className = 'button button--default single-date-confirm';
                        confirmBtn.textContent = 'Select Date';
                        confirmBtn.onclick = (e) => {
                            e.preventDefault();
                            const date = selectedDates[0];
                            fromInput.value = flatpickr.formatDate(date, 'Y-m-d');
                            toInput.value = flatpickr.formatDate(date, 'Y-m-d');
                            valueSpan.textContent = flatpickr.formatDate(date, 'j M Y');
                            this.close();
                            dropdownElement.classList.remove('show');
                        };
                        this.calendarContainer.appendChild(confirmBtn);
                    }
                } else if (selectedDates.length === 2) {
                    const [from, to] = selectedDates;
                    fromInput.value = flatpickr.formatDate(from, 'Y-m-d');
                    toInput.value = flatpickr.formatDate(to, 'Y-m-d');

                    // Check if dates are the same
                    if (from.getTime() === to.getTime()) {
                        valueSpan.textContent = flatpickr.formatDate(from, 'j M Y');
                    } else {
                        valueSpan.textContent = `${flatpickr.formatDate(from, 'j M Y')} - ${flatpickr.formatDate(to, 'j M Y')}`;
                    }

                    const confirmBtn = this.calendarContainer.querySelector('.single-date-confirm');
                    if (confirmBtn) {
                        confirmBtn.remove();
                    }

                    this.close();
                    dropdownElement.classList.remove('show');
                }
            },
            onOpen: () => {
                event?.stopPropagation();
            },
            onClose: (selectedDates, dateStr, instance) => {
                dropdown.removeAttribute('data-calendar-open');

                if(selectedDates.length == 1){
                    instance.setDate([selectedDates[0],selectedDates[0]], true);
                }
            },
        });

        button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            if (dropdown.hasAttribute('data-calendar-open')) {
                picker.close();
            } else {
                picker.open();
                dropdown.setAttribute('data-calendar-open', 'true');
            }
        });

        dropdown.setAttribute('data-flatpickr-initialized', 'true');
    });
};

document.addEventListener('DOMContentLoaded', initializeDateRangePicker);
document.addEventListener('htmx:afterSettle', initializeDateRangePicker);
